module.exports = __webpack_public_path__ + "img/lg_ring_y_e_0_0.45309d77.png";